var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.24 857.6h512c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48h-512c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zM492.8 668.555l-254.923-238.032c-8.137-7.597-20.668-6.912-27.99 1.531s-6.661 21.446 1.475 29.043l287.387 268.345c7.537 7.038 18.978 7.038 26.515 0l287.374-268.345c8.136-7.598 8.797-20.601 1.474-29.043s-19.854-9.128-27.99-1.53l-254.923 238.043v-611.093c0-10.534-8.596-19.073-19.2-19.073s-19.2 8.539-19.2 19.073v611.082z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.a2629ccd1f87cf2e059fb22e8ba46b0d.svg";
export { ForwardRef as ReactComponent };